import React, { useEffect, useRef, useState } from 'react';
import { MdExpandMore } from 'react-icons/md';

const DropDown = ({ text, wrapperClass, className, buttonClass, iconClass, iconSize, children, icon = MdExpandMore }) => {
    const ref = useRef();
    const [visible, setVisible] = useState(false);

    const handleClick = e => {
        if (ref.current.contains(e.target)) {
            return;
        }

        setVisible(false);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    const Icon = icon;

    return (
        <div ref={ref} className={className} style={{ position: 'relative' }}>
            <button className={buttonClass} onClick={() => setVisible(!visible)}>
                {
                    typeof text == 'function'
                        ? (text())
                        : (text)
                }
                <Icon className={iconClass} size={iconSize} />
            </button>
            {visible && (
                <div className={wrapperClass} style={{ position: 'absolute' }}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default DropDown;